:host {
  --description-color: var(--stzh-cardlist-description-color, inherit);
  --background-color: var(--stzh-cardlist-background-color, inherit);
}

.stzh-cardlist {
  &__cards {
    display: grid;
    gap: $gridGutter;

    @include mq($from: small) {
      gap: $gridGutterSmall;
    }

    @include mq($from: medium) {
      gap: $gridGutterMedium;
    }

    @include mq($from: large) {
      gap: $gridGutterLarge;
    }

    @include mq($from: ultra) {
      gap: $gridGutterUltra;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    @include mq($from: medium) {
      // was smallheader before
      flex-direction: row;
    }
  }

  &__footer:not(:empty) {
    @include spaceCurve("margin-top", "regular");
  }

  &__description {
    @include fontCurve("p1");
    --stzh-icon-color: #{$colorPrimary70};

    &:not(:empty) {
      margin-bottom: space("xsmall");

      @include mq($from: medium) {
        // was smallheader before
        margin-bottom: 0;
      }
    }

    ::slotted(stzh-heading) {
      --color: var(--description-color);
    }
  }

  &__switch {
    --color: inherit;
    align-self: end;
  }

  /* Has content inside header */

  &:has(#{&}__description:not(:empty)) &__header,
  &--has-toggle-link &__header {
    @include spaceCurve("margin-bottom", "regular");
  }

  /* Subpages layout variant */

  &--layout-subpages &__cards:has(stzh-card-navigation:not([has-lead])),
  &--layout-subpages &__cards:has(stzh-pi-content-navigation:not([has-lead])) {
    @include spaceCurve("row-gap", "tiny");

    @include mq($from: medium) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      padding-left: 0;
    }
  }

  &--layout-subpages &__cards:has(stzh-pi-content-navigation:not([has-lead])) {
    @include mq($from: large) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  &--layout-subpages &__cards:has(stzh-card-navigation[has-lead]),
  &--layout-subpages &__cards:has(stzh-pi-content-navigation[has-lead]) {
    @include spaceCurve("row-gap", "regular");

    @include mq($from: small) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @include mq($from: large) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  /* Teasers and Pi Teasers layout variant */

  &--layout-teasers &__cards,
  &--layout-pi-teasers &__cards {
    @include spaceCurve("row-gap", "medium");

    @include mq($from: small) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @include mq($from: medium) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @include mq($from: large) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }

  &--layout-teasers#{&}--max-3-cols &__cards,
  &--layout-pi-teasers#{&}--max-3-cols &__cards {
    @include mq($from: large) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  /* Searchresults layout variant */

  &--layout-searchresults &__cards {
    gap: space("xlarge");
  }

  /* Fullwidth layout variant (e.g. for MeinKonto dashboard) */

  &--layout-fullwidth &__cards {
    @include spaceCurve("gap", "regular");
  }

  /* Pi Teasers variant */
  &--layout-pi-teasers {
    background-color: var(--background-color);
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    width: calc(100vw - var(--stzh-scrollbar-width));
    max-width: calc(100vw - var(--stzh-scrollbar-width));
    @include spaceCurve("padding-top", "big");
    @include spaceCurve("padding-bottom", "big");
  }

  &--layout-pi-teasers &__header,
  &--layout-pi-teasers &__cards {
    @include container();
  }
}
